import { caseTrackerApis } from '@shared/apis';
import { genericMutationWithId, genericQueryWithId } from './generics';

export const useSyncCaseTrackerHubspot =
  genericMutationWithId<caseTrackerApis.SyncCaseTrackerHubspot>(
    caseTrackerApis.syncCaseTrackerHubspot
  );

export const useGetCaseTracker = genericQueryWithId<caseTrackerApis.GetCaseTracker>(
  caseTrackerApis.getCaseTracker
);
